import React from 'react';
import { SelectPicker } from 'rsuite';
import { useLocation } from './../hooks/useLocation';

export const ToolbarOrder = () => {
  const { params, go } = useLocation();

  const { order } = params;

  return (
    <SelectPicker
      placeholder="Sorting"
      searchable={false}
      cleanable={false}
      defaultValue=""
      value={order || ''}
      data={[
        { value: '', label: 'Default sorting' },
        { value: 'title', label: '1-9 / A-Z' },
        // { value: 'stock_status', label: 'Stock status' },
        // { value: "popularity", label: "Sort by popularity" },
        // { value: "rating", label: "Sort by average rating" },
        { value: 'date', label: 'Sort by newness' },
        { value: 'price', label: 'Sort by price: low to high' },
        { value: 'price-desc', label: 'Sort by price: high to low' },
      ]}
      onChange={(v) => {
        go({ ...params, order: v });
      }}
    />
  );
};
